import React from 'react';
import { ClockIcon, ArchiveIcon, UserIcon, LockIcon, CompassIcon, MessageSquareIcon } from 'lucide-react';
import { reasons, reasonsIntro } from '../data/reasons';
import type { Reason } from '../types/content';
const icons: Record<Reason['icon'], React.ComponentType<{
  className?: string;
}>> = {
  clock: ClockIcon,
  archive: ArchiveIcon,
  user: UserIcon,
  lock: LockIcon,
  compass: CompassIcon,
  message: MessageSquareIcon
};
export function WhyChoose() {
  return <section id="por-que-elegirnos" className="bg-sage-50" data-id="element-183" data-mp="32fhwu6j3b1l2">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-184" data-mp="32eynvfbf3nj6">
        <div className="max-w-3xl" data-id="element-185" data-mp="2of75l2dvbkzd">
          <h2 className="font-display text-2xl font-semibold leading-snug text-emerald-900 sm:text-4xl" data-id="element-186" data-mp="2oi3710oxcrsk">
            ¿Por qué elegir trabajar conmigo?
          </h2>
          <div className="hairline mt-6 h-px w-32" aria-hidden="true" data-id="element-187" data-mp="1d00olzd2wejo" />
          <p className="mt-6 text-base leading-relaxed text-graphite-700" data-id="element-188" data-mp="1i0g1yqxd1m1n">{reasonsIntro}</p>
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-189" data-mp="28dvw8qh4q9vj">
          {reasons.map(reason => {
          const Icon = icons[reason.icon];
          return <li key={reason.id} className="rounded-sm border border-sage-200 bg-ivory-50 p-7 shadow-[0_1px_2px_rgba(28,32,27,0.04)]" data-id="element-190" data-mp="2iclg2osl64ef">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-gold-400/60 bg-gold-300/15" data-id="element-191" data-mp="2rdjkh86xsdxj">
                  <Icon className="h-5 w-5 text-gold-600" aria-hidden="true" data-id="element-192" data-mp="2mdf2fdqdrb57" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-emerald-900" data-id="element-193" data-mp="312b66ylem200">
                  {reason.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-graphite-700" data-id="element-194" data-mp="2w6cm3n73z65e">{reason.text}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}